import router from '@/router';

export function getSafeRedirectUrl(redirectUrl: string | undefined | null): string | null {
  if (!redirectUrl || typeof redirectUrl !== 'string') return null;
  if (!redirectUrl.startsWith('/') || redirectUrl.startsWith('//')) return null;

  // Prevent redirect loops in auth flow
  const blockedPaths = ['/sign-in', '/auth/callback', '/maintenance'];
  if (blockedPaths.some((path) => redirectUrl.startsWith(path))) return null;

  // Validate against actual routes
  const resolved = router.resolve(redirectUrl);
  if (resolved.matched[0]?.path === '/:pathMatch(.*)*') return null;

  return redirectUrl;
}
